import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGooglecardboardComponent } from './simple-icons-googlecardboard.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGooglecardboardComponent ],
    exports:      [ SimpleIconsGooglecardboardComponent ],
    bootstrap:    []
})
export class SimpleIconsGooglecardboardModule {}
